"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _textArea = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-area"));

var _listGroup = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/list-group"));

var _chip = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/chip"));

var _form = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/form"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ResolveModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ResolveModal, _PureComponent);

  var _super = _createSuper(ResolveModal);

  function ResolveModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ResolveModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      newMessage: (0, _translations.t)('Control', 'topic_moderation.reported_content.resolve.private_message', {
        topicTitle: _this.props.topicTitle
      })
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (message) {
      _this.setState({
        newMessage: message
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ResolveModal, [{
    key: "render",
    value: function render() {
      var _filteredReportedCont;

      var _this$props = this.props,
          onResolve = _this$props.onResolve,
          onClose = _this$props.onClose,
          reportedContent = _this$props.reportedContent,
          error = _this$props.error;
      var newMessage = this.state.newMessage;
      var user = (0, _insidedDataStorage.getInsidedData)('user');
      var filteredReportedContent = reportedContent === null || reportedContent === void 0 ? void 0 : reportedContent.filter(function (_ref) {
        var reportedBy = _ref.reportedBy;
        return reportedBy.username !== user.name;
      });
      var usernames = (_filteredReportedCont = filteredReportedContent === null || filteredReportedContent === void 0 ? void 0 : filteredReportedContent.map(function (_ref2) {
        var reportedBy = _ref2.reportedBy;
        return reportedBy.username;
      })) !== null && _filteredReportedCont !== void 0 ? _filteredReportedCont : [];
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: "Resolve reported content"
      }), (0, _preact.h)(_modal.ModalBody, null, usernames.length === 0 ? 'The selected report(s) will not be shown on the topic page anymore.' : (0, _preact.h)(_form.default, null, (0, _preact.h)("div", null, "By resolving the reported content, the user(s) who reported this post will be notified via a private message. You may modify the message below. Subsequently, the report(s) will not be shown on the topic page."), (0, _preact.h)(_inputUnit.default, {
        label: "To"
      }, (0, _preact.h)("div", {
        className: "resolve-modal-metadata-container"
      }, (0, _preact.h)(_listGroup.default, {
        spacing: "8px"
      }, filteredReportedContent.map(function (_ref3) {
        var id = _ref3.id,
            reportedBy = _ref3.reportedBy;
        return (0, _preact.h)(_chip.default, {
          key: id,
          variant: "squared",
          size: "small",
          startIcon: (0, _preact.h)(_UserAvatar.default, {
            user: _objectSpread(_objectSpread({}, reportedBy), {}, {
              name: reportedBy.username,
              url: "/member/profile/?userid=".concat(reportedBy.id)
            }),
            style: {
              width: '20px',
              height: '20px'
            },
            openInNewTab: true
          })
        }, reportedBy.username);
      })))), (0, _preact.h)(_inputUnit.default, {
        label: "Message",
        error: error !== null && error !== void 0 ? error : undefined
      }, (0, _preact.h)(_textArea.default, {
        onContentChange: this.handleChange,
        value: newMessage,
        verticalResize: true,
        size: "fullWidth",
        maxLength: 250
      })))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: "Resolve",
        variant: "success",
        onClick: function onClick() {
          return onResolve(usernames, newMessage);
        },
        size: "medium",
        "data-element-name": "confirm resolve button",
        "data-track-type": "click"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        onClick: onClose,
        size: "medium",
        "data-element-name": "cancel resolve button",
        "data-track-type": "click"
      })));
    }
  }]);
  return ResolveModal;
}(_preactCompat.PureComponent);

var _default = ResolveModal;
exports.default = _default;